import { Callback1 } from '@deqo/foundation';
import { Point } from '../../platform/geom/Point';
import { Rect } from '../../platform/geom/Rect';


export type CommandWizardStepHandler = Callback1<any, string>;

export interface CommandWizardStep {
    name: string;
    syntax: string;
    message: string;
    handler: CommandWizardStepHandler;
}

export type CommandWizard = CommandWizardStep[];

const defaultSyntax = (name: string, defau1t: any) => {
    const left = name;
    const right = defau1t !== undefined ? `=${defau1t}` : '';
    return `[${left}${right}]`;
};

const wizardStep = (name: string, syntax: string, message: string, handler: CommandWizardStepHandler): CommandWizardStep =>
    ({ name, syntax, message, handler });

export const booleanStep = (name: string, message: string, defau1t?: boolean) => wizardStep(
    name,
    defaultSyntax(name, defau1t),
    message ?? `Enter ${name}: `,
    input => {
        if (input === null || input === undefined || input === '') return defau1t;
        input = input.toString().toLowerCase();
        return ['y', 'yes', 'true', 't'].includes(input);
    }
);

export const stringStep = (name: string, message?: string, defau1t?: string) => wizardStep(
    name,
    defaultSyntax(name, defau1t),
    message ?? `Enter ${name}: `,
    input => input ?? defau1t
);

export const numberStep = (name: string, message?: string, defau1t?: number) => wizardStep(
    name,
    defaultSyntax(name, defau1t),
    message ?? `Enter ${name}: `,
    input => {
        const n = parseFloat(input);
        return isNaN(n) ? defau1t : n;
    }
);

export const pointStep = (name: string, message?: string) => wizardStep(
    name,
    `[${name}X], [${name}Y]`,
    message ?? `Enter ${name} position in the following format: x, y`,
    input => Point.from(input).toArray(),
);

export const rectStep = (name: string, message?: string) => wizardStep(
    name,
    `[${name}X] [${name}Y] [${name}W] [${name}H]`,
    message ?? `Enter ${name} rectangle in the following format: x, y, w, h`,
    input => Rect.parse(input),
);
